import tblOrder from "../_ApiConn/apiTableOrder";


const getWaitingForApprov = async () => {
    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.getWaitingForApprov({ token });

    return (dFromF);
}
const getAllTableOrders = async () => {
    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.getAllTableOrders({ token });

    return (dFromF);
}

const getAllOrdersByDates = async (startDTS, endDTS) => {
    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.getAllOrdersByDates({ startDTS, endDTS, token });

    return (dFromF);
}

const orderMyTable = async (obj) => {

    let token = localStorage.getItem("token");

    let dFromF = await tblOrder.orderMyTable({ obj, token });
    return (dFromF);
}


const getTableOrderBySearch = async (txtToSearch) => {
    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.getTableOrderBySearch({ txtToSearch, token });
    return (dFromF);
}

const updateTableStatus = async (orderId, newStatus) => {

    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.updateTableStatus({ orderId, newStatus, token });
    return (dFromF);
}


const getTableOrder = async (orderID) => {
    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.getTableOrder({ orderID, token });

    return (dFromF);
}

const updateTableOrder = async (orderId, objToUpdate) => {

    let token = localStorage.getItem("token");
    let dFromF = await tblOrder.updateTableOrder({ orderId, objToUpdate, token });
    return (dFromF);
}


export default {
    getWaitingForApprov,
    orderMyTable,
    getTableOrderBySearch,
    getAllTableOrders,
    updateTableStatus,
    getAllOrdersByDates,
    getTableOrder,
    updateTableOrder
};